import { createContext, useContext } from 'react';

import type { ILeadMessagesMode } from 'src/pages/landlord/leads/messages/context/mode/types';

export const LeadMessagesModeContext = createContext<ILeadMessagesMode | undefined>(undefined);

export const useLeadMessagesMode = (): ILeadMessagesMode => {
    const context = useContext(LeadMessagesModeContext);

    if (!context) {
        throw new Error('useLeadMessagesMode must be used within a LeadMessagesMode provider');
    }

    return context;
};
